import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { useAppSelector } from '../redux/helper';
import { selectNotificationsSyncScope } from '../redux/notificationsSlice';
import { syncNotificationsSoon } from '../services/notificationsSync';

/** How often the web app, which gets no pushes, asks for new notices. */
export const WEB_NOTIFICATIONS_POLL_MS = 60_000;

/**
 * Keeps the inbox in step with the server on every platform: a pull on
 * start, once login has set both the employee and the location, on a
 * location switch and on return to the app (on web, to the tab). Web gets
 * no pushes, so it also asks every minute while the tab is visible.
 */
export default function useNotificationsSync(): void {
  const scope = useAppSelector(selectNotificationsSyncScope);

  useEffect(() => {
    syncNotificationsSoon();
  }, [scope]);

  useEffect(() => {
    const subscription = AppState.addEventListener('change', state => {
      if (state === 'active') syncNotificationsSoon();
    });
    return () => subscription.remove();
  }, []);

  useEffect(() => {
    if (Platform.OS !== 'web') return undefined;
    const timer = setInterval(() => {
      if (AppState.currentState === 'active') syncNotificationsSoon();
    }, WEB_NOTIFICATIONS_POLL_MS);
    return () => clearInterval(timer);
  }, []);
}
